import { ApiErrorCode } from "config/errorCodes";
import {
  isBetterAuthSessionNotFresh,
  normalizeStepUpRequestError,
} from "lib/better-auth-reauthentication";
import { ServerError } from "utils/genericUtilityFunctions";

export function isStepUpAuthenticationRequired(error: unknown): boolean {
  if (isBetterAuthSessionNotFresh(error)) {
    return true;
  }

  const serverError = normalizeStepUpRequestError(error);
  if (!serverError || serverError.status_code !== 403) {
    return false;
  }

  return serverError.code === ApiErrorCode.AUTHENTICATION_RECONFIRMATION_REQUIRED;
}

export function getStepUpAuthenticationMessage(error: unknown): string {
  const serverError = normalizeStepUpRequestError(error);
  if (serverError instanceof ServerError && serverError.message.trim()) {
    return serverError.message;
  }

  return "For your security, sign in again to continue.";
}
